import { FunctionComponent, MouseEvent } from 'react'
import Icon from 'components/shared/Icon'

const SaveOrDiscard:FunctionComponent<SaveOrDiscardProps> = ({ onSave, onDiscard }) => (
  <span className='save-or-discard'>
    <a href={undefined} onClick={onDiscard} title='Discard changes' className='pointer'>
      <Icon name={{ 'icon-replay': true }} />
    </a>
    <a href={undefined} onClick={onSave} title='Save changes' className='pointer'>
      <Icon name={{ 'icon-content-save': true }} />
    </a>
  </span>
)

interface SaveOrDiscardProps {
  onSave: (e: MouseEvent<HTMLAnchorElement>) => void;
  onDiscard: (e: MouseEvent<HTMLAnchorElement>) => void;
}

export default SaveOrDiscard
